import { render } from "./PropertyFolderEditor.vue?vue&type=template&id=25fd68d3&scoped=true&ts=true"
import script from "./PropertyFolderEditor.vue?vue&type=script&lang=ts"
export * from "./PropertyFolderEditor.vue?vue&type=script&lang=ts"

import "./PropertyFolderEditor.vue?vue&type=style&index=0&id=25fd68d3&scoped=true&lang=css"

import exportComponent from "/home/steffen/IdeaProjects/Antara/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25fd68d3"]])

export default __exports__